<template>
  <div class="ims-tab ml-0">
    <router-link to="/reports/customers" class="inv-btn">
      <button class="btn" v-bind:class="{ 'active': $route.name == 'customers' }">
        Customers
      </button>
    </router-link>
    <router-link to="/reports/customers/scheduler">
      <button class="btn" v-bind:class="{ 'active': $route.name == 'eodScheduler' }">
        Scheduler
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "EodTabs"
};
</script>

<style scoped>
.ims-tab button {
  text-transform: none;
}
</style>
